export type Expiration = {
  year: number;
  month: number;
};

export const isExpired = (expiration: Expiration) => {
  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return expiration.year < year || (expiration.year === year && expiration.month < month);
};

export const stringifyExpirationDate = (expiration: Expiration) => {
  return `${expiration.month <= 9 ? '0' : ''}${expiration.month}/${expiration.year}`;
};
